import { useState, Suspense, useEffect, useRef } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Layout from './layouts/Layout.jsx';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { AppContext, appStore } from './context/AppContext.js';
import Login from './pages/login/Login.jsx';
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { baseUrl, menuOptions } from './global.js';
import axios from 'axios';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import NoPage from './pages/notfound/NoPage.jsx';
import SockJS from "sockjs-client/dist/sockjs";
import { Client } from "@stomp/stompjs";
import ResetPassword from './pages/reset/ResetPassword.jsx';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

function App() {
  const clientRef = useRef(null);
  const updateClient = appStore(state => state.updateSClient);
  
  const [loadingFirebase, setLoadingFirebase] = useState(true);

  const getSyncInitialState = () => {
    if (localStorage.getItem("sanaToken") !== null) {
      let tData = jwtDecode(localStorage.getItem("sanaToken"));
      
      return {
        ...tData.role[0].tokenPayload
      };
    } else {
      return null;
    }
  };

  useEffect(() => {

    const sock = new SockJS(`${baseUrl}/ws`, null, {
      withCredentials: true
    });

    if (localStorage.getItem("sanaToken") !== null) {
      let tData = jwtDecode(localStorage.getItem("sanaToken"));
      
      if (Date.now() >= tData.exp * 1000) {
        localStorage.clear();
        window.location.replace('/');

      }

      //setLoadingFirebase(false);
    }

    const stompClient = new Client({
      webSocketFactory: () => sock,
      reconnectDelay: 5000,
      onConnect: () => {
        //console.log("Connected to WebSocket");
        setLoadingFirebase(false);
        clientRef.current = stompClient;
    
        updateClient(clientRef);
      },
      onStompError: (frame) => {
        console.error("Broker error", frame);
      }
    });
        
    stompClient.activate();

    return () => {
      // Clean up on unmount
      if (clientRef.current) {
        clientRef.current.deactivate();
      }
    }

  },[])

  const [tokenData, setTokenData] = useState(getSyncInitialState());
  
  // let myaudio = new Audio(audio);
  // let updateNotifCount = appStore(state => state.increaseCount);
  // let updateDashboard = appStore(state => state.updateDashboardData);

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("sanaToken")}`;


  return (
    <ErrorBoundary fallback={<p style={{textAlign:'center'}}>Something went wrong <button onClick={() => {window.location.reload();}}>reload</button></p>}>
      <AppContext.Provider value={tokenData}>
        
        {tokenData === null ? 
        
        <BrowserRouter>
            <Routes>
              <Route key={300} path="/" element={<Login update={setTokenData}/>} />
              <Route key={301} path='/reset-password' element={<ResetPassword />} />
              
              <Route path="*" element={<NoPage />} />
            </Routes>
          </BrowserRouter>
        
        
        
        : 
        
        loadingFirebase ? 
        <div style={{ height:'65vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <div className='loader'>
          </div>
        </div> :
        <Suspense fallback={<p style={{textAlign:'center'}}>Loading.....</p>}>
          <BrowserRouter>
            <Routes>
              <Route key={200} path="/" element={<Layout menu={menuOptions}/> }>
              
              {
                menuOptions.map((menu, index) => (
                  menu.roles.includes(tokenData.roleID) ? 
                  <Route key={index+1} path={menu.path} element={<menu.comp />} /> : null
                )

                )
              }
                
                <Route path="*" element={<NoPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </Suspense>
        
        
        }
        <ToastContainer position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnHover
          theme="light" />
      </AppContext.Provider>
    </ErrorBoundary>
      
      //

  );
}

export default App;